import { render, staticRenderFns } from "./ReglamentoConstruccion.vue?vue&type=template&id=191743f2&scoped=true"
import script from "./ReglamentoConstruccion.vue?vue&type=script&lang=js"
export * from "./ReglamentoConstruccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191743f2",
  null
  
)

export default component.exports